export function getCols<T>(number: number, arr: Array<T>): Array<Array<T>> {
  const a = Array.from({ length: number }, () => [] as Array<T>);

  for (let i = 0; i < arr.length; i++) {
    a[i % number].push(arr[i]);
  }

  return a;
}
